/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_MessageInputs */

const vi_order_gift_message = /** @type {(inputs: Order_Gift_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lời nhắn`)
};

/**

* @param {Order_Gift_MessageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_message = /** @type {((inputs?: Order_Gift_MessageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_MessageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_message(inputs)
});